// @flow

import * as React from 'react';
import Group from 'sail/Group';
import {Text} from 'sail/Text';
import type {BrandIconType} from 'sail/BrandIcon/types';
import {useAccount} from 'docs/data';
import {normalizeHostname} from 'docs/util';
import {PaymentMethodIcon} from './PaymentMethodIcon';

type PaymentMethodProps = {|
  type: BrandIconType,
  label: string,
  size?: string,
  href?: string,
  sublabel?: string,
|};

export const PaymentMethod = ({
  type,
  label,
  size = 'medium',
  href,
  sublabel,
}: PaymentMethodProps) => {
  const {account} = useAccount();
  const linkHref = href ? normalizeHostname(href, account.hosts) : null;
  const content = (
    <Group direction="horizontal" spacing={8} alignItems="center">
      <PaymentMethodIcon type={type} size={size} />
      <Group>
        <Text
          display="block"
          size={14}
          lineHeight={16}
          color="dark"
          weight="medium"
        >
          {label}
        </Text>
        {sublabel && (
          <Text display="block" size={12} lineHeight={16} color="gray">
            {sublabel}
          </Text>
        )}
      </Group>
    </Group>
  );
  if (linkHref) {
    return <a href={linkHref}>{content}</a>;
  }
  return content;
};
